import React from 'react';
import PropTypes from 'prop-types';
import { Button, CurrencyFormat } from '@lt/components';

import styles from './priceBadge.module.css';

const PriceBadge = ({ value, onClick, currencyCode, currencySymbol }) =>
  !value ? (
    <span className={styles.priceBadge}>
      <span>от __ ___</span> <span>{currencySymbol}</span>
    </span>
  ) : (
    <Button functional className={styles.priceBadge} onClick={onClick}>
      <span>от&nbsp;</span>
      <CurrencyFormat value={value} currencyCode={currencyCode} />
    </Button>
  );

PriceBadge.propTypes = {
  value: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

PriceBadge.defaultProps = {
  value: null,
};

export default PriceBadge;
